export const filterTypes = {
  ALL: 'ALL',
  SELECTED: 'SELECTED',
  DAY: 'DAY',
  RESOURCE: 'RESOURCE',
  DAY_AND_RESOURCE: 'DAY_AND_RESOURCE'
}
